<template>
  <!-- eslint-disable -->
  <v-dialog v-model="show" max-width="800px" persistent>
    <v-card>
      <v-card-title>
        <h3>Calamity Notification Recipient List</h3>
      </v-card-title>
      <v-card-text>
        <v-form v-model="valid" ref="form" lazy-validation>
          <v-textarea class="notification-recipients-textarea" filled name="Emails" placeholder="Notification Recipients" validate-on-blur :rules="[rulesRequired]"  v-model="notificationRecipients" ></v-textarea>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn class="close-edit-email-dialog-btn" color="primary" text @click.stop="show=false">Close</v-btn>
        <v-btn class="save-edit-email-dialog-btn" color="primary" :disabled="saving || !valid" text @click.stop="saveEmails()">Save</v-btn>
        <v-progress-circular v-show="saving" indeterminate color="primary"></v-progress-circular>
      </v-card-actions>
    </v-card>
  </v-dialog>
<!-- eslint-enable -->
</template>
<script>
import { mapGetters } from "vuex";
import { CALAMITY_NAMESPACE } from "./store/calamityStore";
import RulesMixin from "@/mixins/RulesMixin.js";
export default {
  name: "EditClientEmail",
  mixins: [RulesMixin],
  data() {
    return {
      calamityId: null,
      notificationRecipients: null,
      saving: false,
      show: false,
      valid: true
    };
  },
  computed: {
    ...mapGetters(CALAMITY_NAMESPACE, [])
  },
  created: /* istanbul ignore next */ function() {
    this.$parent.$on("editClientEmail", this.showDialog);
  },
  methods: {
    saveEmails() {
      if (this.$refs.form && this.$refs.form.validate()) {
        this.saving = true;
        return this.$store
          .dispatch(`${CALAMITY_NAMESPACE}/EDIT_CLIENT_EMAIL`, {
            calamityId: this.calamityId,
            notificationRecipients: this.notificationRecipients
          })
          .then(res => {
            this.calamityId = null;
            this.notificationRecipients = null;
            this.show = false;
            this.saving = false;
          })
          .catch(
            /* istanbul ignore next */ () => {
              this.saving = false;
            }
          );
      }
    },
    showDialog(payload) {
      this.calamityId = payload.calamityId;
      this.notificationRecipients = payload.notificationRecipients;
      this.show = true;
    }
  }
};
</script>
